import { useState, useEffect } from 'react';

// Global cache to prevent duplicate API calls across all components
let cachedLogoData = null;
let fetchPromise = null;
const subscribers = new Set();

function notifySubscribers(data) {
  cachedLogoData = data;
  subscribers.forEach(cb => cb(data));
}

function useCachedLogo() {
  const [logoData, setLogoData] = useState(cachedLogoData);

  useEffect(() => {
    // If already cached, use it immediately
    if (cachedLogoData) {
      setLogoData(cachedLogoData);
      return;
    }

    // Subscribe to updates
    const subscriber = (data) => setLogoData(data);
    subscribers.add(subscriber);

    // Only fetch if not already fetching
    if (!fetchPromise) {
      fetchPromise = fetch(`${process.env.REACT_APP_API_URL}/api/logo`)
        .then(res => {
          if (!res.ok) throw new Error('Failed to fetch logo');
          return res.json();
        })
        .then(data => {
          notifySubscribers(data);
          return data;
        })
        .catch(err => {
          console.error('Error fetching logo:', err);
          fetchPromise = null; // Allow retry on next mount
          throw err;
        });
    }

    return () => {
      subscribers.delete(subscriber);
    };
  }, []);

  // Helper to get full storage URL
  const getStorageUrl = (path) => {
    if (!path) return '';
    return path.startsWith('http') ? path : `${process.env.REACT_APP_API_URL}/storage/${path}`;
  };

  return {
    logo: logoData?.[0]?.logo || null,
    mobileLogo: logoData?.[0]?.mobile_logo || null,
    favicon: logoData?.[0]?.favicon || null,
    loaderLogo: logoData?.[0]?.loader_logo || null,
    getStorageUrl,
  };
}

export default useCachedLogo;
